import { render } from "./HistoryViewer.vue?vue&type=template&id=0fcaf6d6&scoped=true"
import script from "./HistoryViewer.vue?vue&type=script&lang=js"
export * from "./HistoryViewer.vue?vue&type=script&lang=js"

import "./HistoryViewer.vue?vue&type=style&index=0&id=0fcaf6d6&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/plus.centrodeglaucoma.com/darmin-plus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fcaf6d6"]])

export default __exports__